import { observer } from "mobx-react";
import * as React from "react";
import styled from "styled-components";

import DashboardContent from "@client/components/modules/DashboardModules/DashboardContent";
import ListTemplate from "@client/components/templates/ListTemplate";
import customerStore from "@client/stores/CustomerStore";
import licenceStore from "@client/stores/LicenceStore";
import licensorStore from "@client/stores/LicensorStore";
import { isLocationAvailable } from "@client/utils/Constants";
import objectUtils from "@client/utils/objectUtils";
import tagStore from "@client/stores/TagStore";
import partnerStore from "@client/stores/PartnerStore";

const Wrapper = styled.div`
  height: 100%;
`;
@observer
class DashboardPage extends React.Component {
  pollRef: any;
  pageHeaderRef: any | null = null;
  isMounted = false;

  componentDidMount() {
    this.isMounted = true;
    this.poll(true);
    this.loadAdminData();
  }

  componentWillUnmount() {
    this.isMounted = false;
    clearTimeout(this.pollRef);
    partnerStore.cancelRequests("all");
    partnerStore.clearCustomers();
    partnerStore.clearLicences();
    partnerStore.clearLicensors();
  }

  async loadAdminData(showLoading = false) {
    await objectUtils.waitUntil(() => licensorStore.tokenInfo !== null);
    const loadLicensors = async () => {
      if (isLocationAvailable("/licensors", licensorStore.tokenInfo)) {
        await licensorStore.load({ hideLoading: !showLoading });
      }
    };
    const loadPartners = async () => {
      if (isLocationAvailable("/partners", licensorStore.tokenInfo)) {
        await Promise.all([
          partnerStore.load({ hideLoading: !showLoading }),
          partnerStore.loadLicences("all"),
          partnerStore.loadCustomers("all"),
        ]);
      }
    };
    await Promise.all([loadLicensors(), loadPartners()]);
  }

  async poll(showLoading = false) {
    await Promise.all([
      customerStore.load({ hideLoading: !showLoading }),
      licenceStore.load({ hideLoading: !showLoading }),
      tagStore.load({ hideLoading: !showLoading }),
      this.loadAdminData(showLoading),
    ]);
    if (!this.isMounted) {
      return;
    }
    this.pollRef = setTimeout(() => {
      this.poll();
    }, 2000);
  }

  render() {
    return (
      <Wrapper>
        <ListTemplate
          title="Dashboard"
          listComponent={
            <DashboardContent
              customers={customerStore.customers}
              licences={licenceStore.licences}
              licensors={licensorStore.licensors}
              customersLoading={customerStore.loading}
              licencesLoading={licenceStore.loading}
              licensorsLoading={licensorStore.loading}
              partners={partnerStore.partners}
              partnersLoading={partnerStore.loading}
              partnersLicences={partnerStore.licences}
              partnersCustomers={partnerStore.customers}
              tokenInfo={licensorStore.tokenInfo}
              tags={tagStore.tags}
              tagsLoading={tagStore.loading}
              onNewCustomerClick={() => {
                this.pageHeaderRef.handleNewItem("customer");
              }}
              onNewLicenceClick={() => {
                this.pageHeaderRef.handleNewItem("licence");
              }}
              onNewPartnerClick={() => {
                this.pageHeaderRef.handleNewItem("partner");
              }}
            />
          }
          pageHeaderRef={ref => {
            this.pageHeaderRef = ref;
          }}
          listNoMargin
          footerText=""
        />
      </Wrapper>
    );
  }
}

export default DashboardPage;
